// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background: #12394d;
  box-sizing: border-box;
  min-height: 86px;
  padding-left: 32px;
  padding-right: 32px;
  width: 100%;
}

.header-logo {
  align-items: center;
  background: transparent;
  display: flex;
  margin: 8px 0;
  max-width: min(520px, 48vw);
  padding: 0;
}

.header-logo img {
  display: block;
  height: auto;
  width: 100%;
}

.logo {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  cursor: pointer;
}

.corner-button-style {
  display: flex;
  justify-content: left;
  padding-left: 40px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.arabic-corner-button {
  align-items: center;
  border-color: rgba(255, 255, 255, 0.72);
  border-width: 2px;
  color: #ffffff;
  display: inline-flex;
  font-size: 22px;
  height: 58px;
  justify-content: center;
  line-height: 1;
  padding: 0 26px;
}

.arabic-give-button .btn {
  align-items: center;
  display: inline-flex;
  font-size: 24px;
  height: 58px;
  justify-content: center;
  line-height: 1;
  padding: 0 34px;
}

.arabic-corner-button:hover,
.arabic-corner-button:focus-visible {
  background: rgba(255, 255, 255, 0.12);
  border-color: #ffffff;
  color: #ffffff;
}

.nav-items {
  display: flex;
  align-items: center;
  gap: 16px;
}

.items {
  display: flex;
}

.arabic-give-button {
  margin: 0;
}

.arabic-new-button {
  margin: 0;
}

@media (max-width: 850px) {
  .navbar {
    padding-left: 20px;
    padding-right: 20px;
  }

  .header-logo {
    max-width: 48vw;
    padding: 5px 8px;
  }

  .nav-items {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    margin: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/header.rtl.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,YAAY;EACd;AACF","sourcesContent":[".navbar {\n  background: #12394d;\n  box-sizing: border-box;\n  min-height: 86px;\n  padding-left: 32px;\n  padding-right: 32px;\n  width: 100%;\n}\n\n.header-logo {\n  align-items: center;\n  background: transparent;\n  display: flex;\n  margin: 8px 0;\n  max-width: min(520px, 48vw);\n  padding: 0;\n}\n\n.header-logo img {\n  display: block;\n  height: auto;\n  width: 100%;\n}\n\n.logo {\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n  cursor: pointer;\n}\n\n.corner-button-style {\n  display: flex;\n  justify-content: left;\n  padding-left: 40px;\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n\n.arabic-corner-button {\n  align-items: center;\n  border-color: rgba(255, 255, 255, 0.72);\n  border-width: 2px;\n  color: #ffffff;\n  display: inline-flex;\n  font-size: 22px;\n  height: 58px;\n  justify-content: center;\n  line-height: 1;\n  padding: 0 26px;\n}\n\n.arabic-give-button .btn {\n  align-items: center;\n  display: inline-flex;\n  font-size: 24px;\n  height: 58px;\n  justify-content: center;\n  line-height: 1;\n  padding: 0 34px;\n}\n\n.arabic-corner-button:hover,\n.arabic-corner-button:focus-visible {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: #ffffff;\n  color: #ffffff;\n}\n\n.nav-items {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.items {\n  display: flex;\n}\n\n.arabic-give-button {\n  margin: 0;\n}\n\n.arabic-new-button {\n  margin: 0;\n}\n\n@media (max-width: 850px) {\n  .navbar {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .header-logo {\n    max-width: 48vw;\n    padding: 5px 8px;\n  }\n\n  .nav-items {\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    margin: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
